import * as React from "react";

import { UitkCardAloha, UitkCardAlohaView } from "uitk-react-cards";
import {
  UitkFigureAspectRatioType as ExperimentalAspectRatioType,
  UitkImage as ExperimentalImage,
  UitkFigure as ExperimentalFigure,
} from "uitk-react-experimental-images";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";

export type ScrimCardProps = {
  id: string;
  className: string;
  titleSlot?: JSX.Element | JSX.Element[];
  aspectRatio: ExperimentalAspectRatioType;
  backgroundImageURL: string;
  subtitleSlot?: JSX.Element | JSX.Element[];
  footerSlot?: JSX.Element | JSX.Element[];
};

export const ScrimCard: React.FC<ScrimCardProps> = ({
  id,
  className,
  titleSlot,
  aspectRatio,
  backgroundImageURL,
  subtitleSlot = null,
  footerSlot = null,
}) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 2 };
  const subheadingCols: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 1 };

  return (
    <section id={id}>
      <UitkCardAloha className={className} border={true}>
        <UitkCardAlohaView>
          <ExperimentalFigure ratio={aspectRatio}>
            <ExperimentalImage alt="" src={backgroundImageURL} />

            <UitkScrim type={UitkScrimType.OVERLAY}>
              <UitkLayoutFlex
                direction="column"
                justifyContent="space-between"
                className="all-x-padding-three"
                style={{ height: "inherit" }}
              >
                <UitkLayoutFlexItem className="all-t-padding-six s-t-padding-zero">
                  <div>
                    {titleSlot && titleSlot}
                    {subtitleSlot && (
                      <UitkLayoutGrid columns={mainGridColumns} className="all-t-padding-three">
                        <UitkLayoutGridItem colSpan={subheadingCols}>{subtitleSlot}</UitkLayoutGridItem>
                      </UitkLayoutGrid>
                    )}
                  </div>
                </UitkLayoutFlexItem>

                {footerSlot && (
                  <UitkLayoutFlexItem>
                    <div>{footerSlot}</div>
                  </UitkLayoutFlexItem>
                )}
              </UitkLayoutFlex>
            </UitkScrim>
          </ExperimentalFigure>
        </UitkCardAlohaView>
      </UitkCardAloha>
    </section>
  );
};
